import React from "react"

// Card do teste de estresse, extraido do App.js em
// 08/10/2026. Puro: recebe os dados e os dois ajudantes
// do colapsavel, e nao guarda estado nenhum.
export default function CardEstresse({ stress, medAbre, setMedAberta, s }) {
  return (
    <>
          {stress && stress.escadas && !medAbre("stress", stress) && (
            <button onClick={() => setMedAberta(x => ({...x, stress: true}))}
              style={{...s.card, display:"flex", justifyContent:"space-between",
                alignItems:"center", width:"100%", textAlign:"left",
                cursor:"pointer"}}>
              <span style={{color:"#e5e7eb", fontSize:13}}>
                🧪 Teste de estresse
              </span>
              <span style={{color:"#6b7280", fontSize:10}}>
                {stress.veredito ? stress.veredito.palavra : ""}
                {stress.veredito && stress.veredito.pior_usd != null
                  ? " · pior caso $"
                    + Math.abs(stress.veredito.pior_usd).toFixed(0) : ""}
                {"  ▼"}
              </span>
            </button>
          )}
          {stress && stress.escadas && medAbre("stress", stress) && (
            <button onClick={() => setMedAberta(x => ({...x, stress: false}))}
              style={{display:"block", width:"100%", textAlign:"right",
                background:"transparent", border:"none", color:"#4b5563",
                fontSize:10, padding:"2px 2px 0 0", cursor:"pointer"}}>
              ▲ recolher
            </button>
          )}
          {stress && stress.escadas && medAbre("stress", stress) && (
            <div style={s.card}>
              <p style={s.cardTitle}>🧪 Teste de estresse</p>
              <p style={{fontSize:11, color:"#6b7280", lineHeight:1.5}}>
                Se o fator cair, quanto cai a carteira. Responde <b>se</b>, nunca <b>com que probabilidade</b> — a chance e assunto do Monte Carlo, na 💎. A exposição de um ETF à vista ao que ele detém vem do prospecto, então aqui nada é estimado.
              </p>
              {Object.keys(stress.por_fator || {}).sort().map(f => (
                <div key={f} style={{marginBottom:12}}>
                  <p style={{color:"#e2e8f0", fontSize:13, margin:"8px 0 4px"}}>
                    <b>{f}</b> · {stress.por_fator[f].peso_pct.toFixed(1)}%
                    {" · " + stress.por_fator[f].ativos
                      .concat((stress.por_fator[f].estimados || [])
                        .map(x => x.symbol)).join(", ")}
                  </p>
                  {(stress.por_fator[f].estimados || []).map(x => (
                    <div key={x.symbol} style={{fontSize:10, color:"#eab308",
                      lineHeight:1.5, marginBottom:4}}>
                      {x.symbol + ": beta " + x.beta.toFixed(2)
                        + " ESTIMADO em " + x.dias + " pregões, R² "
                        + x.r2.toFixed(2) + " — o índice explica "
                        + Math.round(x.r2 * 100) + "% deste papel. O resto"}
                      {" é risco da empresa, que este card não enxerga."}
                    </div>
                  ))}
                  {(stress.escadas[f] || []).map(e => (
                    <div key={e.choque_pct} style={{display:"flex", justifyContent:"space-between", fontSize:12}}>
                      <span style={{color:"#9ca3af"}}>{f} {e.choque_pct}%</span>
                      <span style={{color:"#ef4444"}}>
                        {e.carteira_pct.toFixed(2)}%
                        {" · $" + Math.abs(e.carteira_usd).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              ))}
              {stress.cenarios && stress.cenarios.length > 0 && (
                <div style={{marginTop:14}}>
                  <p style={{color:"#e2e8f0", fontSize:13, margin:"0 0 2px"}}>
                    <b>Cenários combinados</b>
                  </p>
                  <p style={{fontSize:10, color:"#6b7280", lineHeight:1.5}}>
                    Aqui cada cenário diz o movimento de TODOS os fatores de uma vez. Os números são premissas escolhidas, não medidas — por isso eles aparecem, para você poder discordar.
                  </p>
                  {stress.cenarios.map(c => (
                    <div key={c.nome} style={{padding:"5px 0"}}>
                      <div style={{display:"flex", justifyContent:"space-between", fontSize:12}}>
                        <span style={{color:"#9ca3af"}}>{c.nome}</span>
                        <span style={{color:"#ef4444"}}>
                          {c.carteira_pct.toFixed(2)}%
                          {" · $" + Math.abs(c.carteira_usd).toFixed(2)}
                        </span>
                      </div>
                      <div style={{fontSize:10, color:"#4b5563"}}>
                        {Object.keys(c.choques).sort()
                          .map(k => k + " " + c.choques[k] + "%").join(" · ")}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {stress.replay && stress.replay.length > 0 && (
                <div style={{marginTop:14}}>
                  <p style={{color:"#e2e8f0", fontSize:13, margin:"0 0 2px"}}>
                    <b>Replay histórico</b>
                  </p>
                  <p style={{fontSize:10, color:"#6b7280", lineHeight:1.5}}>
                    A carteira de hoje atravessando janelas que de fato aconteceram. Este bloco não assume nada sobre correlação: ela foi a que foi, inclusive indo a 1 quando foi.
                  </p>
                  {stress.replay.map(r => (
                    <div key={r.nome} style={{padding:"5px 0"}}>
                      <div style={{display:"flex", justifyContent:"space-between", fontSize:12}}>
                        <span style={{color:"#9ca3af"}}>{r.nome}</span>
                        <span style={{color:"#ef4444"}}>
                          {r.carteira_pct.toFixed(2)}%
                          {" · $" + Math.abs(r.carteira_usd).toFixed(2)}
                        </span>
                      </div>
                      <div style={{fontSize:10, color:"#4b5563"}}>
                        {r.de} a {r.ate}
                        {" · " + Object.keys(r.fatores).sort()
                          .map(k => k + " " + r.fatores[k].toFixed(1) + "%")
                          .join(" · ")}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {stress.acerto && (
                <div style={{marginTop:14}}>
                  <p style={{color:"#e2e8f0", fontSize:13, margin:"0 0 2px"}}>
                    <b>O mapa confere?</b>
                  </p>
                  <p style={{fontSize:10, color:"#6b7280", lineHeight:1.5}}>
                    Compara, nos mesmos pesos, o que o mapa previa com o que os ativos deram. Não é medidor de exatidão: o ETF fecha às 16h de Nova York e a cripto negocia 24 horas, então existe um piso de erro que nenhum conserto remove. É alarme de ordem de grandeza.
                  </p>
                  <div style={{display:"flex", justifyContent:"space-between", fontSize:12}}>
                    <span style={{color:"#9ca3af"}}>
                      {"erro típico em " + stress.acerto.dias + " pregões"}
                      {stress.acerto.cobre_pct != null
                        ? ", em " + stress.acerto.cobre_pct + "% da carteira"
                        : ""}
                    </span>
                    <span style={{color: stress.acerto.erro_mediano_pp <= 1
                      ? "#22c55e" : "#f59e0b"}}>
                      {stress.acerto.erro_mediano_pp.toFixed(2)} pp
                    </span>
                  </div>
                  <div style={{display:"flex", justifyContent:"space-between", fontSize:12}}>
                    <span style={{color:"#9ca3af"}}>maior erro do período</span>
                    <span style={{color:"#9ca3af"}}>
                      {stress.acerto.erro_maximo_pp.toFixed(2)} pp
                    </span>
                  </div>
                  {(stress.acerto.piores || []).slice(0, 1).map(x => (
                    <div key={x.dia} style={{fontSize:10, color:"#4b5563"}}>
                      {"pior dia " + x.dia + ": previa "
                        + x.previsto_pct.toFixed(2) + "%, deu "
                        + x.real_pct.toFixed(2) + "%"}
                    </div>
                  ))}
                  {stress.fonte2 && (
                    <div style={{display:"flex",
                      justifyContent:"space-between", fontSize:12}}>
                      <span style={{color:"#9ca3af"}}>
                        {"segunda fonte, " + stress.fonte2.conferidas
                          + " de " + stress.fonte2.possiveis
                          + " comparações"}
                      </span>
                      <span style={{color:
                        stress.fonte2.conferidas < stress.fonte2.possiveis
                          ? "#f59e0b"
                          : (stress.fonte2.max_pp <= 1
                            ? "#22c55e" : "#f59e0b")}}>
                        {stress.fonte2.max_pp.toFixed(2)} pp
                      </span>
                    </div>
                  )}
                  {stress.fonte2 && stress.fonte2.onde ? (
                    <div style={{fontSize:10, color:"#4b5563"}}>
                      {"maior discordância em " + stress.fonte2.onde}
                    </div>
                  ) : null}
                  {stress.fonte2 && (
                    <p style={{fontSize:10, color:"#4b5563",
                      lineHeight:1.5}}>
                      A segunda fonte confere o replay contra outro
                      provedor de preço, a {stress.fonte2.fonte}. Cobre
                      só os fatores cripto: no SPY a fonte gratuita não
                      ajusta dividendo, e a diferença seria do
                      dividendo, não erro de medição.
                    </p>
                  )}
                  <p style={{fontSize:10, color:"#4b5563", lineHeight:1.5}}>
                    A linha de 1pp sai desta medida, não de um padrão de mercado. Erro muito acima dela significa mapa quebrado, ativo sem fator ou grupamento não refletido — nunca mercado imprevisível.
                  </p>
                </div>
              )}
              <p style={{fontSize:10, color:"#4b5563", lineHeight:1.5}}>
                Nas escadas um fator se move por vez e os outros ficam parados por construção, não por previsão; nos cenários e no replay todos se movem juntos. Cobertura: {stress.cobertura_pct.toFixed(1)}
                {"% do valor."}
                {(stress.nao_mapeados && stress.nao_mapeados.length)
                  ? " Fora do mapa: " + stress.nao_mapeados
                      .map(x => x.symbol).join(", ") + "." : ""}
                {" Não inclui taxa do ETF nem ágio, irrelevantes"}
                {" num choque de um dia."}
              </p>
              {stress.veredito && (
                <div style={{marginTop:12, paddingTop:10,
                  borderTop:"1px solid #1f2937"}}>
                  <p style={{color:"#e2e8f0", fontSize:13, margin:"0 0 4px"}}>
                    <b>Veredito</b>
                  </p>
                  <p style={{fontSize:15, fontWeight:"bold", margin:"0 0 4px",
                    color: stress.veredito.palavra === "concentrado" ? "#f59e0b"
                      : stress.veredito.palavra === "inclinado" ? "#eab308"
                      : "#22c55e"}}>
                    {stress.veredito.palavra}
                  </p>
                  <p style={{fontSize:11, color:"#9ca3af", lineHeight:1.5, margin:0}}>
                    {stress.veredito.peso_pct + "% da carteira responde"}
                    {" a um fator só (" + stress.veredito.fator + ")."}
                    {stress.veredito.pior_nome
                      ? " Pior caso entre todos os blocos: "
                        + (/^[A-Z\u00C0-\u00DA](?![A-Z\u00C0-\u00DA])/.test(stress.veredito.pior_nome)
                            ? stress.veredito.pior_nome.charAt(0).toLowerCase() + stress.veredito.pior_nome.slice(1)
                            : stress.veredito.pior_nome)
                        + " (" + stress.veredito.pior_pct.toFixed(2) + "%, $"
                        + Math.abs(stress.veredito.pior_usd).toFixed(2) + ")."
                      : ""}
                  </p>
                  <p style={{fontSize:10, color:"#4b5563", lineHeight:1.5,
                    marginTop:4}}>
                    As três palavras descrevem EXPOSIÇÃO, nunca direção: concentrado, inclinado, repartido. Este card não diz comprar nem vender — se dissesse, estaria prevendo, que é o que ele recusa.
                  </p>
                </div>
              )}
            </div>
          )}
          <div style={{height:48}} />
    </>
  )
}
